export var GooglePayButtonSizeModeEnumsObj = {
    STATIC: "static",
    FILL: "fill",
};
